import { Link } from 'react-router-dom';
import { novels } from '@/mocks/novels';

export default function HotRanking() {
  const ranked = [...novels].sort((a, b) => b.rating - a.rating).slice(0, 10);

  const getRankBadge = (rank: number) => {
    if (rank === 1) return 'bg-accent-500';
    if (rank === 2) return 'bg-accent-400';
    if (rank === 3) return 'bg-accent-300';
    return 'bg-secondary-400';
  };

  return (
    <section className="w-full px-4 md:px-6 py-14 md:py-20 bg-background-50">
      <div className="max-w-7xl mx-auto">
        <div className="flex items-end justify-between mb-10">
          <div>
            <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-900">
              热门排行
            </h2>
            <p className="text-sm text-foreground-500 mt-2">读者评分最高的都市爽文佳作</p>
          </div>
          <div className="flex items-center gap-2">
            <span className="w-4 h-4 flex items-center justify-center text-accent-500">
              <i className="ri-fire-line text-sm"></i>
            </span>
            <span className="text-xs text-foreground-500">实时更新</span>
          </div>
        </div>

        <div className="grid grid-cols-1 lg:grid-cols-2 gap-4 md:gap-5">
          {ranked.map((novel, index) => (
            <Link
              key={novel.id}
              to={`/article/${novel.id}`}
              className="group flex items-center gap-4 p-4 rounded-lg border border-background-200/70 bg-background-50 hover:border-primary-200 hover:bg-background-100/50 transition-all duration-200 cursor-pointer"
            >
              <div className={`w-8 h-8 md:w-9 md:h-9 flex items-center justify-center rounded-full ${getRankBadge(index + 1)} text-background-50 font-heading font-bold text-sm flex-shrink-0`}>
                {index + 1}
              </div>

              <div className="w-14 h-20 md:w-16 md:h-22 flex-shrink-0 rounded overflow-hidden">
                <img
                  src={novel.coverImage}
                  alt={novel.title}
                  title={`${novel.title} 评分 ${novel.rating}`}
                  className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
                />
              </div>

              <div className="flex-1 min-w-0">
                <h3 className="font-heading text-sm md:text-base font-semibold text-foreground-900 group-hover:text-primary-600 transition-colors duration-200 truncate">
                  {novel.title}
                </h3>
                <p className="text-xs text-foreground-500 mt-1">{novel.author} · {novel.category}</p>
                <p className="text-xs text-foreground-400 mt-1 line-clamp-2 leading-relaxed hidden sm:block">
                  {novel.description}
                </p>
              </div>

              <div className="flex flex-col items-end gap-1.5 flex-shrink-0">
                <div className="flex items-center gap-0.5">
                  <span className="w-3 h-3 flex items-center justify-center text-accent-500">
                    <i className="ri-star-fill text-[10px]"></i>
                  </span>
                  <span className="text-sm font-bold text-accent-500">{novel.rating}</span>
                </div>
                <span className="text-[10px] text-foreground-400">{novel.wordCount}</span>
              </div>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}